import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';
import { RosettaService } from './services/rosetta.service';
import { BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import { MatToolbar } from '@angular/material/toolbar';
import { MatButton } from '@angular/material/button';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [MatToolbar, RouterLink, MatButton, MatTabNav, MatTabLink, RouterLinkActive, MatTabNavPanel, RouterOutlet]
})
export class AppComponent implements OnInit {
  private authService = inject(AuthService);
  private rosetta = inject(RosettaService);
  private router = inject(Router);

  title = 'rosetta-browser';
  public apiKey: string = null;
  public $ready: Observable<boolean>;
  private readySubject: BehaviorSubject<boolean>;

  constructor() {
    this.readySubject = new BehaviorSubject(false);
    this.$ready = this.readySubject.asObservable();
  }

  get isAuthenticated(): boolean { return this.authService.isAuthenticated; }

  ngOnInit(): void {
    this.authService.$isAuthenticated.subscribe(isAuthenticated => {
      if (isAuthenticated) {
        firstValueFrom(this.rosetta.getCodeSystems())
          .then(() => this.readySubject.next(true));
      }
    });

    if (!this.authService.isAuthenticated) {
      this.router.navigate(['login']);
    }
  }

  signIn(): void {
    this.router.navigate(['login']);
  }

  signOut(): void {
    this.rosetta.codeSystems = [];
    this.apiKey = null;
    this.authService.onSignOut();
    this.router.navigate(['login']);
  }
}
